<app-breadcrumb [home]="home" [items]="breadcrumbs" />

<header class="page-header">
  <h2>{{ editando ? 'Editar parceiro' : 'Cadastrar parceiro' }}</h2>
</header>

@if (loading()) {
  <app-loading />
} @else {
  @if (editando) {
    <!-- A aba "Empresas" só existe em edição — o parceiro precisa existir para ter escopo de
         empresas para editar. Cada `p-tabpanel` já carrega o conteúdo certo sozinho. -->
    <!-- [lazy]="true": sem isso o PrimeNG monta os dois p-tabpanel de uma vez, e
         app-partner-companies dispara GET partners/{id}/companies e GET companys?PageSize=1000
         assim que a tela abre, mesmo que o operador nunca saia da aba Dados. O `hasBeenRendered`
         do PrimeNG mantém o painel montado após a primeira visita, então trocar de aba não
         recarrega. -->
    <p-tabs [value]="abaAtiva()" (valueChange)="mudarAba($event)" [lazy]="true">
      <p-tablist>
        <p-tab [value]="0">Dados</p-tab>
        <p-tab [value]="1">Empresas</p-tab>
        @if (canListContracts()) {
          <p-tab [value]="2">Contratos</p-tab>
        }
        @if (canViewReferrals()) {
          <p-tab [value]="3">Indicações</p-tab>
        }
      </p-tablist>
      <p-tabpanels>
        <p-tabpanel [value]="0">
          <ng-container [ngTemplateOutlet]="formTemplate" />
        </p-tabpanel>
        <p-tabpanel [value]="1">
          <app-partner-companies [partnerId]="partnerId()!" />
        </p-tabpanel>
        @if (canListContracts()) {
          <!-- Contrato de Parceria Comercial (card 3462). Nome e e-mail vão como padrão da modal
               "Gerar contrato" (nome curto e e-mail do representante). -->
          <p-tabpanel [value]="2">
            <app-partner-contracts
              [partnerId]="partnerId()!"
              [partnerName]="form.value.name ?? ''"
              [partnerEmail]="form.value.email ?? ''" />
          </p-tabpanel>
        }
        @if (canViewReferrals()) {
          <!-- Indique e ganhe (card 3461): quem indicou este parceiro e quem ele indicou. -->
          <p-tabpanel [value]="3">
            <app-partner-referrals [partnerId]="partnerId()!" />
          </p-tabpanel>
        }
      </p-tabpanels>
    </p-tabs>
  } @else {
    <ng-container [ngTemplateOutlet]="formTemplate" />
  }
}

<ng-template #formTemplate>
  <!-- `(ngSubmit)` é o único disparo do envio: o `app-button` com `type="submit"` já sobe
       pelo submit nativo, e somar `(sendButtonClick)` faria o handler rodar duas vezes no
       mesmo clique — foi assim que nasceram deals duplicados no card 2902. -->
  <form class="partner-form" [formGroup]="form" (ngSubmit)="salvar()">
    <div class="partner-form__card">
      <app-input
        label="Nome"
        type="text"
        placeholder="Nome do parceiro"
        [required]="true"
        [formGroup]="form"
        controlName="name" />

      <app-input
        label="E-mail"
        type="email"
        placeholder="parceiro@empresa.com.br"
        [required]="true"
        [formGroup]="form"
        controlName="email" />

      <p class="partner-form__hint">
        @if (editando) {
          O e-mail é o login do parceiro. Ele só pode ser alterado enquanto o convite não tiver sido
          aceito — depois disso seria trocar a identidade de quem já entra na plataforma.
        } @else {
          É por aqui que ele recebe o convite para criar a senha, e é o login dele daqui em diante.
        }
      </p>

      <app-input
        label="Telefone"
        type="useMask"
        mask="(99) 99999-9999"
        placeholder="(00) 00000-0000"
        [required]="true"
        [formGroup]="form"
        controlName="phoneNumber" />
    </div>

    <div class="partner-form__actions">
      <app-button label="Cancelar" [theme]="'white'" type="button" (sendButtonClick)="voltar()" />

      <app-button
        [label]="editando ? 'Salvar' : 'Cadastrar e convidar'"
        icon="pi pi-check"
        type="submit"
        [isLoading]="saving()"
        [disabled]="saving()" />
    </div>
  </form>
</ng-template>
